import Swiper from 'swiper';

document.addEventListener('DOMContentLoaded', () => {
  const productCardSlider = new Swiper('.js-product-card-slider', {
    slidesPerView: 1,
    spaceBetween: 0,
  });

  // productCardSlider.init();
});
